<template>
  <el-dialog
    :title="$t('salesCenter.transferLead')"
    :visible.sync="dialogVisible"
    width="480px"
    custom-class="MyDialog"
    @close="closeDialog"
    append-to-body
  >
    <el-form class="handover-clue" ref="handoverForm" label-width="70px">
      <div class="handover-tip">{{ $t('salesCenter.transferLeadTip') }}</div>
      <el-form-item class="form-item-staff" :label="$t('salesCenter.selectStaff')">
        <el-select v-model="handoverStaff" filterable :placeholder="$t('salesCenter.pleaseSelectStaff')">
          <el-option
            v-for="item in staffList"
            :key="item.userId"
            :label="item.userName"
            :value="item.userId"
          >
          </el-option>
        </el-select>
        <div class="help-text">{{ $t('salesCenter.onlyNormalStaffCanTransfer') }}</div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('app.cancel') }}</el-button>
      <el-button @click="transferCustom" type="primary">{{ $t('app.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { getCampusNormalUsers } from "@/api/CallCenter";
import { changeCustomCrOwner,changeCustomOwner } from "@/api/studentDetails";
import LoginUserHelper from "@/util/LoginUserHelper";

export default {
  props: {
    showTransferClueDialog: {
      type: Boolean,
      default: false
    },
    currentCustomId: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      // 转交线索
      dialogVisible: false,
      staffList: [], // 员工列表
      handoverStaff: '',
    };
  },
  watch: {
    showTransferClueDialog(val) {
      this.dialogVisible = val;
      if (val) {
        this.fetchStaffList();
      } else {
        this.resetForm();
      }
    },
  },
  mounted() {
    this.dialogVisible = this.showTransferClueDialog;
  },
  methods: {
    // 转交线索按钮点击
    fetchStaffList () {
      this.resetForm();
      getCampusNormalUsers({}).then(ret => {
        if (ret.code === 0) {
          this.staffList = ret.data || [];
        }
      });
    },
    // 转交线索
    transferCustom() {
      const params = {
        customIds: this.currentCustomId,
        newOwner: this.handoverStaff,
        agentUserId: LoginUserHelper.getUserInfo().id,
        pointType: 8900902,
      };
      changeCustomOwner(params).then(ret => {
        if (ret.code === 0) {
          this.$message({ message: this.$t('app.transferSuccess'), type: "success" });
          this.closeDialog();
          this.$emit('update:clueList');
        } else {
          this.$message({ message: this.$getCodeMessage(ret.code, ret.message, ret.messageArgs) || this.$t('app.transferFail'), type: "warning" });
        }
      }).catch(error => {
        this.$message({ message: this.$t('app.transferFail'), type: "error" });
      });
    },
    closeDialog() {
      this.dialogVisible = false;
      this.resetForm();
      this.$emit('update:closeTransferClueDialog');
    },
    resetForm() {
      this.handoverStaff = '';
    },
  }
};
</script>

<style lang="scss" scoped>
// 线索转交
.handover-clue {
	padding: 0 20px;
	.handover-tip {
		line-height: 24px;
		margin-bottom: 12px;
		color: #333;
		font-size: 14px;
	}
	.help-text {
		color: #EE4B4E;
		font-size: 12px;
		line-height: 18px;
		margin-top: 2px;
	}
	.form-item-staff {
		margin-bottom: 0;
	}
}
</style>
